import { Directive, ElementRef, Renderer2 } from "@angular/core";
import { NzMenuDividerDirective } from "ng-zorro-antd/menu";

@Directive({
  selector: "[ui-menu-divider]",
  exportAs: "uiMenuDivider",
})
export class UiMenuDividerDirective extends NzMenuDividerDirective {
  public constructor(public elementRef: ElementRef, renderer: Renderer2) {
    super(elementRef, renderer);
  }
}
